import React from 'react'
import CategoryTile from 'components/Luxkit/CategoryTile'

interface Props {
    href: string;
    image: App.Image;
    heading: string;
}

function TopPicksForMeCategoryTile(props: Props) {
  const { href, image, heading } = props

  return <CategoryTile
    to={href}
    image={image}
    heading={heading}
    align="bottom"
  />
}

export default TopPicksForMeCategoryTile
